import { render, staticRenderFns } from "./redirectUrlParkingPay.vue?vue&type=template&id=88948ff6&scoped=true&"
import script from "./redirectUrlParkingPay.vue?vue&type=script&lang=js&"
export * from "./redirectUrlParkingPay.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "88948ff6",
  null
  
)

export default component.exports